// extracted by mini-css-extract-plugin
var _1 = "Loading__Loading___bLuIA";
var _2 = "Loading__spinner___IxIGc";
var _3 = "Loading__wiggle___oSp8F";
export { _1 as "Loading", _2 as "spinner", _3 as "wiggle" }
